import { logUsage } from 'owa-analytics';

export function logDriveIdNotFound() {
    logUsage('FluidDriveIdNotFound', undefined, { isCore: true });
}

export function logNoBPOSForDriveId(functionName: string) {
    logUsage(
        'FluidNoBPOSForDriveId',
        {
            function: functionName,
        },
        { isCore: true }
    );
}
